"use client";

import { c as _c } from "react/compiler-runtime";
import { useFeatureMenu } from "@hooks/use-feature-menu";
import { useTranslations } from "next-intl";
import { AppSidebarGroup } from "@components/app/app-sidebar/app-sidebar-group";
import { useAppSelector } from "@lib/redux/hooks";
import { selectSessionUser } from "@features/application/app-selectors";
import { selectCurrentWorkspace } from "@features/workspaces/workspaces-selectors";
import { workspacesTools } from "@features/workspaces/workspaces-tools";
interface NavWorkspaceProps {
  isPrivateMode?: boolean | undefined;
}
export const NavWorkspace = t0 => {
  const $ = _c(20);
  const {
    isPrivateMode
  } = t0;
  const t = useTranslations("features.workspaces.ui.nav-workspace");
  const workspace = useAppSelector(selectCurrentWorkspace);
  const user = useAppSelector(selectSessionUser);
  let t1;
  if ($[0] !== isPrivateMode || $[1] !== user || $[2] !== workspace) {
    t1 = (localeAs, pageInfo) => workspacesTools.buildSidebarMenuItems(localeAs, workspace, pageInfo, user, isPrivateMode);
    $[0] = isPrivateMode;
    $[1] = user;
    $[2] = workspace;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const menuItems = useFeatureMenu(t1);
  let t2;
  if ($[4] !== isPrivateMode || $[5] !== workspace) {
    t2 = (localeAs_0, pageInfo_0) => isPrivateMode ? [] : workspacesTools.buildSidebarQuickActionsMenuItems(localeAs_0, workspace, pageInfo_0);
    $[4] = isPrivateMode;
    $[5] = workspace;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const quickActionsMenuItems = useFeatureMenu(t2);
  if (!workspace) {
    return null;
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== menuItems || $[10] !== t3) {
    t4 = <AppSidebarGroup title={t3} items={menuItems} />;
    $[9] = menuItems;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t) {
    t5 = t("quickLinks");
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== quickActionsMenuItems || $[15] !== t5) {
    t6 = <AppSidebarGroup title={t5} items={quickActionsMenuItems} hiddenOnCollapsible={true} />;
    $[14] = quickActionsMenuItems;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};